export default __webpack_public_path__ + "static/media/women.2ceb6964.webp";